import moment from "moment";
import ApiClient from "../apiClient";
import { Anticipo, CURRENCY, SERVICE_RESPONSE } from "./Const";

export function setUserFieldValueDefault(userFields, index, field) {

    switch (index) {
        case 0:
            userFields.userFields1 = validateNull(field.Dflt);
            break;
        case 1:
            userFields.userFields2 = validateNull(field.Dflt);
            break;
        case 2:
            userFields.userFields3 = validateNull(field.Dflt);
            break;
        case 3:
            userFields.userFields4 = validateNull(field.Dflt);
            break;
        case 4:
            userFields.userFields5 = validateNull(field.Dflt);
            break;
        case 5:
            userFields.userFields6 = validateNull(field.Dflt);
            break;
        case 6:
            userFields.userFields7 = validateNull(field.Dflt);
            break;
        case 7:
            userFields.userFields8 = validateNull(field.Dflt);
            break;
        case 8:
            userFields.userFields9 = validateNull(field.Dflt);
            break;
        case 9:
            userFields.userFields10 = validateNull(field.Dflt);
            break;
        case 10:
            userFields.userFields11 = validateNull(field.Dflt);
            break;
        case 11:
            userFields.userFields12 = validateNull(field.Dflt);
            break;
        case 12:
            userFields.userFields13 = validateNull(field.Dflt);
            break;
        case 13:
            userFields.userFields14 = validateNull(field.Dflt);
            break;
        case 14:
            userFields.userFields15 = validateNull(field.Dflt);
            break;
        case 15:
            userFields.userFields16 = validateNull(field.Dflt);
            break;
        case 16:
            userFields.userFields17 = validateNull(field.Dflt);
            break;
        case 17:
            userFields.userFields18 = validateNull(field.Dflt);
            break;
        case 18:
            userFields.userFields19 = validateNull(field.Dflt);
            break;
        case 19:
            userFields.userFields20 = validateNull(field.Dflt);
            break;
        case 20:
            userFields.userFields21 = validateNull(field.Dflt);
            break;
        case 21:
            userFields.userFields22 = validateNull(field.Dflt);
            break;
        case 22:
            userFields.userFields23 = validateNull(field.Dflt);
            break;
        case 23:
            userFields.userFields24 = validateNull(field.Dflt);
            break;
        case 24:
            userFields.userFields25 = validateNull(field.Dflt);
            break;
        case 25:
            userFields.userFields26 = validateNull(field.Dflt);
            break;
        case 26:
            userFields.userFields27 = validateNull(field.Dflt);
            break;
        case 27:
            userFields.userFields28 = validateNull(field.Dflt);
            break;
        case 28:
            userFields.userFields29 = validateNull(field.Dflt);
            break;
        case 29:
            userFields.userFields30 = validateNull(field.Dflt);
            break;
        case 30:
            userFields.userFields31 = validateNull(field.Dflt);
            break;
        case 31:
            userFields.userFields32 = validateNull(field.Dflt);
            break;
        case 32:
            userFields.userFields33 = validateNull(field.Dflt);
            break;
        case 33:
            userFields.userFields34 = validateNull(field.Dflt);
            break;
        case 34:
            userFields.userFields35 = validateNull(field.Dflt);
            break;
        case 35:
            userFields.userFields36 = validateNull(field.Dflt);
            break;
        case 36:
            userFields.userFields37 = validateNull(field.Dflt);
            break;
        case 37:
            userFields.userFields38 = validateNull(field.Dflt);
            break;
        case 38:
            userFields.userFields39 = validateNull(field.Dflt);
            break;
        case 39:
            userFields.userFields40 = validateNull(field.Dflt);
            break;
        case 40:
            userFields.userFields41 = validateNull(field.Dflt);
            break;
        case 41:
            userFields.userFields42 = validateNull(field.Dflt);
            break;
        case 42:
            userFields.userFields43 = validateNull(field.Dflt);
            break;
        case 43:
            userFields.userFields44 = validateNull(field.Dflt);
            break;
        case 44:
            userFields.userFields45 = validateNull(field.Dflt);
            break;
        case 45:
            userFields.userFields46 = validateNull(field.Dflt);
            break;
        case 46:
            userFields.userFields47 = validateNull(field.Dflt);
            break;
        case 47:
            userFields.userFields48 = validateNull(field.Dflt);
            break;
        case 48:
            userFields.userFields49 = validateNull(field.Dflt);
            break;
        case 49:
            userFields.userFields50 = validateNull(field.Dflt);
            break;
        case 50:
            userFields.userFields51 = validateNull(field.Dflt);
            break;
        case 51:
            userFields.userFields52 = validateNull(field.Dflt);
            break;
        case 52:
            userFields.userFields53 = validateNull(field.Dflt);
            break;
        case 53:
            userFields.userFields54 = validateNull(field.Dflt);
            break;
        case 54:
            userFields.userFields55 = validateNull(field.Dflt);
            break;
        case 55:
            userFields.userFields56 = validateNull(field.Dflt);
            break;
        case 56:
            userFields.userFields57 = validateNull(field.Dflt);
            break;
        case 57:
            userFields.userFields58 = validateNull(field.Dflt);
            break;
        case 58:
            userFields.userFields59 = validateNull(field.Dflt);
            break;
        case 59:
            userFields.userFields60 = validateNull(field.Dflt);
            break;
        case 60:
            userFields.userFields61 = validateNull(field.Dflt);
            break;
        case 61:
            userFields.userFields62 = validateNull(field.Dflt);
            break;
        case 62:
            userFields.userFields63 = validateNull(field.Dflt);
            break;
        case 63:
            userFields.userFields64 = validateNull(field.Dflt);
            break;
        case 64:
            userFields.userFields65 = validateNull(field.Dflt);
            break;
        case 65:
            userFields.userFields66 = validateNull(field.Dflt);
            break;
        case 66:
            userFields.userFields67 = validateNull(field.Dflt);
            break;
        case 67:
            userFields.userFields68 = validateNull(field.Dflt);
            break;
        case 68:
            userFields.userFields69 = validateNull(field.Dflt);
            break;
        case 69:
            userFields.userFields70 = validateNull(field.Dflt);
            break;
        case 70:
            userFields.userFields71 = validateNull(field.Dflt);
            break;
        case 71:
            userFields.userFields72 = validateNull(field.Dflt);
            break;
        case 72:
            userFields.userFields73 = validateNull(field.Dflt);
            break;
        case 73:
            userFields.userFields74 = validateNull(field.Dflt);
            break;
        case 74:
            userFields.userFields75 = validateNull(field.Dflt);
            break;
        case 75:
            userFields.userFields76 = validateNull(field.Dflt);
            break;
        case 76:
            userFields.userFields77 = validateNull(field.Dflt);
            break;
        case 77:
            userFields.userFields78 = validateNull(field.Dflt);
            break;
        case 78:
            userFields.userFields79 = validateNull(field.Dflt);
            break;
        case 79:
            userFields.userFields80 = validateNull(field.Dflt);
            break;
        case 80:
            userFields.userFields81 = validateNull(field.Dflt);
            break;
        case 81:
            userFields.userFields82 = validateNull(field.Dflt);
            break;
        case 82:
            userFields.userFields83 = validateNull(field.Dflt);
            break;
        case 83:
            userFields.userFields84 = validateNull(field.Dflt);
            break;
        case 84:
            userFields.userFields85 = validateNull(field.Dflt);
            break;
        case 85:
            userFields.userFields86 = validateNull(field.Dflt);
            break;
        case 86:
            userFields.userFields87 = validateNull(field.Dflt);
            break;
        case 87:
            userFields.userFields88 = validateNull(field.Dflt);
            break;
        case 88:
            userFields.userFields89 = validateNull(field.Dflt);
            break;
        case 89:
            userFields.userFields90 = validateNull(field.Dflt);
            break;
        case 90:
            userFields.userFields91 = validateNull(field.Dflt);
            break;
        case 91:
            userFields.userFields92 = validateNull(field.Dflt);
            break;
        case 92:
            userFields.userFields93 = validateNull(field.Dflt);
            break;
        case 93:
            userFields.userFields94 = validateNull(field.Dflt);
            break;
        case 94:
            userFields.userFields95 = validateNull(field.Dflt);
            break;
        case 95:
            userFields.userFields96 = validateNull(field.Dflt);
            break;
        case 96:
            userFields.userFields97 = validateNull(field.Dflt);
            break;
        case 97:
            userFields.userFields98 = validateNull(field.Dflt);
            break;
        case 98:
            userFields.userFields99 = validateNull(field.Dflt);
            break;
        case 99:
            userFields.userFields100 = validateNull(field.Dflt);
            break;
        case 100:
            userFields.userFields101 = validateNull(field.Dflt);
            break;
        case 101:
            userFields.userFields102 = validateNull(field.Dflt);
            break;
        case 102:
            userFields.userFields103 = validateNull(field.Dflt);
            break;
        case 103:
            userFields.userFields104 = validateNull(field.Dflt);
            break;
        case 104:
            userFields.userFields105 = validateNull(field.Dflt);
            break;
        case 105:
            userFields.userFields106 = validateNull(field.Dflt);
            break;
        case 106:
            userFields.userFields107 = validateNull(field.Dflt);
            break;
        case 107:
            userFields.userFields108 = validateNull(field.Dflt);
            break;
        case 108:
            userFields.userFields109 = validateNull(field.Dflt);
            break;
        case 109:
            userFields.userFields110 = validateNull(field.Dflt);
            break;
        case 110:
            userFields.userFields111 = validateNull(field.Dflt);
            break;
        case 111:
            userFields.userFields112 = validateNull(field.Dflt);
            break;
        case 112:
            userFields.userFields113 = validateNull(field.Dflt);
            break;
        case 113:
            userFields.userFields114 = validateNull(field.Dflt);
            break;
        case 114:
            userFields.userFields115 = validateNull(field.Dflt);
            break;
        case 115:
            userFields.userFields116 = validateNull(field.Dflt);
            break;
        case 116:
            userFields.userFields117 = validateNull(field.Dflt);
            break;
        case 117:
            userFields.userFields118 = validateNull(field.Dflt);
            break;
        case 118:
            userFields.userFields119 = validateNull(field.Dflt);
            break;
        case 119:
            userFields.userFields120 = validateNull(field.Dflt);
            break;
        case 120:
            userFields.userFields121 = validateNull(field.Dflt);
            break;
        case 121:
            userFields.userFields122 = validateNull(field.Dflt);
            break;
        case 122:
            userFields.userFields123 = validateNull(field.Dflt);
            break;
        case 123:
            userFields.userFields124 = validateNull(field.Dflt);
            break;
        case 124:
            userFields.userFields125 = validateNull(field.Dflt);
            break;
        case 125:
            userFields.userFields126 = validateNull(field.Dflt);
            break;
        case 126:
            userFields.userFields127 = validateNull(field.Dflt);
            break;
        case 127:
            userFields.userFields128 = validateNull(field.Dflt);
            break;
        case 128:
            userFields.userFields129 = validateNull(field.Dflt);
            break;
        case 129:
            userFields.userFields130 = validateNull(field.Dflt);
            break;
        case 130:
            userFields.userFields131 = validateNull(field.Dflt);
            break;
        default:
            break
    }

    return userFields;
};

export function setUserFieldValue(userFields, index, header, view) {

    switch (index) {
        case 0:
            userFields.userFields1 = validateNull(header.userFields1);
            break;
        case 1:
            userFields.userFields2 = validateNull(header.userFields2);
            break;
        case 2:
            userFields.userFields3 = validateNull(header.userFields3);
            break;
        case 3:
            userFields.userFields4 = validateNull(header.userFields4);
            break;
        case 4:
            userFields.userFields5 = validateNull(header.userFields5);
            break;
        case 5:
            userFields.userFields6 = validateNull(header.userFields6);
            break;
        case 6:
            userFields.userFields7 = validateNull(header.userFields7);
            break;
        case 7:
            userFields.userFields8 = validateNull(header.userFields8);
            break;
        case 8:
            userFields.userFields9 = validateNull(header.userFields9);
            break;
        case 9:
            userFields.userFields10 = validateNull(header.userFields10);
            break;
        case 10:
            userFields.userFields11 = validateNull(header.userFields11);
            break;
        case 11:
            userFields.userFields12 = validateNull(header.userFields12);
            break;
        case 12:
            userFields.userFields13 = validateNull(header.userFields13);
            break;
        case 13:
            userFields.userFields14 = validateNull(header.userFields14);
            break;
        case 14:
            userFields.userFields15 = validateNull(header.userFields15);
            break;
        case 15:
            userFields.userFields16 = validateNull(header.userFields16);
            break;
        case 16:
            userFields.userFields17 = validateNull(header.userFields17);
            break;
        case 17:
            userFields.userFields18 = validateNull(header.userFields18);
            break;
        case 18:
            userFields.userFields19 = validateNull(header.userFields19);
            break;
        case 19:
            userFields.userFields20 = validateNull(header.userFields20);
            break;
        case 20:
            //
            if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                header.userFields21 !== '' ? userFields.userFields21 = validateNull(header.userFields21) : userFields.userFields21 = '99'
            } else {
                userFields.userFields21 = validateNull(header.userFields21);
            }

            break;
        case 21:
            userFields.userFields22 = validateNull(header.userFields22);
            break;
        case 22:
            //

            if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                header.userFields23 !== '' ? userFields.userFields23 = validateNull(header.userFields23) : userFields.userFields23 = '99'
            } else {
                userFields.userFields23 = validateNull(header.userFields23);
            }
            break;
        case 23:
            userFields.userFields24 = validateNull(header.userFields24);
            break;
        case 24:
            //
            if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote') {
                header.userFields25 !== '' ? userFields.userFields25 = validateNull(header.userFields25) : userFields.userFields25 = '99'
            } else {
                userFields.userFields25 = validateNull(header.userFields25);
            }

            break;
        case 25:
            userFields.userFields26 = validateNull(header.userFields26);
            break;
        case 26:
            userFields.userFields27 = validateNull(header.userFields27);
            break;
        case 27:
            userFields.userFields28 = validateNull(header.userFields28);
            break;
        case 28:
            userFields.userFields29 = validateNull(header.userFields29);
            break;
        case 29:
            userFields.userFields30 = validateNull(header.userFields30);
            break;
        case 30:
            userFields.userFields31 = validateNull(header.userFields31);
            break;
        case 31:
            userFields.userFields32 = validateNull(header.userFields32);
            break;
        case 32:
            userFields.userFields33 = validateNull(header.userFields33);
            break;
        case 33:
            userFields.userFields34 = validateNull(header.userFields34);
            break;
        case 34:
            userFields.userFields35 = validateNull(header.userFields35);
            break;
        case 35:
            userFields.userFields36 = validateNull(header.userFields36);
            break;
        case 36:
            userFields.userFields37 = validateNull(header.userFields37);
            break;
        case 37:
            userFields.userFields38 = validateNull(header.userFields38);
            break;
        case 38:
            userFields.userFields39 = validateNull(header.userFields39);
            break;
        case 39:
            userFields.userFields40 = validateNull(header.userFields40);
            break;
        case 40:
            userFields.userFields41 = validateNull(header.userFields41);
            break;
        case 41:
            userFields.userFields42 = validateNull(header.userFields42);
            break;
        case 42:
            userFields.userFields43 = validateNull(header.userFields43);
            break;
        case 43:
            userFields.userFields44 = validateNull(header.userFields44);
            break;
        case 44:
            userFields.userFields45 = validateNull(header.userFields45);
            break;
        case 45:
            userFields.userFields46 = validateNull(header.userFields46);
            break;
        case 46:
            userFields.userFields47 = validateNull(header.userFields47);
            break;
        case 47:
            userFields.userFields48 = validateNull(header.userFields48);
            break;
        case 48:
            userFields.userFields49 = validateNull(header.userFields49);
            break;
        case 49:
            userFields.userFields50 = validateNull(header.userFields50);
            break;
        case 50:
            userFields.userFields51 = validateNull(header.userFields51);
            break;
        case 51:
            userFields.userFields52 = validateNull(header.userFields52);
            break;
        case 52:
            userFields.userFields53 = validateNull(header.userFields53);
            break;
        case 53:
            userFields.userFields54 = validateNull(header.userFields54);
            break;
        case 54:
            userFields.userFields55 = validateNull(header.userFields55);
            break;
        case 55:
            userFields.userFields56 = validateNull(header.userFields56);
            break;
        case 56:
            userFields.userFields57 = validateNull(header.userFields57);
            break;
        case 57:
            userFields.userFields58 = validateNull(header.userFields58);
            break;
        case 58:
            userFields.userFields59 = validateNull(header.userFields59);
            break;
        case 59:
            userFields.userFields60 = validateNull(header.userFields60);
            break;
        case 60:
            userFields.userFields61 = validateNull(header.userFields61);
            break;
        case 61:
            userFields.userFields62 = validateNull(header.userFields62);
            break;
        case 62:
            userFields.userFields63 = validateNull(header.userFields63);
            break;
        case 63:
            userFields.userFields64 = validateNull(header.userFields64);
            break;
        case 64:
            userFields.userFields65 = validateNull(header.userFields65);
            break;
        case 65:
            userFields.userFields66 = validateNull(header.userFields66);
            break;
        case 66:
            userFields.userFields67 = validateNull(header.userFields67);
            break;
        case 67:
            userFields.userFields68 = validateNull(header.userFields68);
            break;
        case 68:
            userFields.userFields69 = validateNull(header.userFields69);
            break;
        case 69:
            userFields.userFields70 = validateNull(header.userFields70);
            break;
        case 70:
            userFields.userFields71 = validateNull(header.userFields71);
            break;
        case 71:
            userFields.userFields72 = validateNull(header.userFields72);
            break;
        case 72:
            userFields.userFields73 = validateNull(header.userFields73);
            break;
        case 73:
            userFields.userFields74 = validateNull(header.userFields74);
            break;
        case 74:
            userFields.userFields75 = validateNull(header.userFields75);
            break;
        case 75:
            userFields.userFields76 = validateNull(header.userFields76);
            break;
        case 76:
            userFields.userFields77 = validateNull(header.userFields77);
            break;
        case 77:
            userFields.userFields78 = validateNull(header.userFields78);
            break;
        case 78:
            userFields.userFields79 = validateNull(header.userFields79);
            break;
        case 79:
            userFields.userFields80 = validateNull(header.userFields80);
            break;
        case 80:
            userFields.userFields81 = validateNull(header.userFields81);
            break;
        case 81:
            userFields.userFields82 = validateNull(header.userFields82);
            break;
        case 82:
            userFields.userFields83 = validateNull(header.userFields83);
            break;
        case 83:
            userFields.userFields84 = validateNull(header.userFields84);
            break;
        case 84:
            userFields.userFields85 = validateNull(header.userFields85);
            break;
        case 85:
            userFields.userFields86 = validateNull(header.userFields86);
            break;
        case 86:
            userFields.userFields87 = validateNull(header.userFields87);
            break;
        case 87:
            userFields.userFields88 = validateNull(header.userFields88);
            break;
        case 88:
            userFields.userFields89 = validateNull(header.userFields89);
            break;
        case 89:
            userFields.userFields90 = validateNull(header.userFields90);
            break;
        case 90:
            userFields.userFields91 = validateNull(header.userFields91);
            break;
        case 91:
            userFields.userFields92 = validateNull(header.userFields92);
            break;
        case 92:
            userFields.userFields93 = validateNull(header.userFields93);
            break;
        case 93:
            userFields.userFields94 = validateNull(header.userFields94);
            break;
        case 94:
            userFields.userFields95 = validateNull(header.userFields95);
            break;
        case 95:
            userFields.userFields96 = validateNull(header.userFields96);
            break;
        case 96:
            userFields.userFields97 = validateNull(header.userFields97);
            break;
        case 97:
            userFields.userFields98 = validateNull(header.userFields98);
            break;
        case 98:
            userFields.userFields99 = validateNull(header.userFields99);
            break;
        case 99:
            userFields.userFields100 = validateNull(header.userFields100);
            break;
        case 100:
            userFields.userFields101 = validateNull(header.userFields101);
            break;
        case 101:
            userFields.userFields102 = validateNull(header.userFields102);
            break;
        case 102:
            userFields.userFields103 = validateNull(header.userFields103);
            break;
        case 103:
            userFields.userFields104 = validateNull(header.userFields104);
            break;
        case 104:
            userFields.userFields105 = validateNull(header.userFields105);
            break;
        case 105:
            userFields.userFields106 = validateNull(header.userFields106);
            break;
        case 106:
            userFields.userFields107 = validateNull(header.userFields107);
            break;
        case 107:
            userFields.userFields108 = validateNull(header.userFields108);
            break;
        case 108:
            userFields.userFields109 = validateNull(header.userFields109);
            break;
        case 109:
            userFields.userFields110 = validateNull(header.userFields110);
            break;
        case 110:
            userFields.userFields111 = validateNull(header.userFields111);
            break;
        case 111:
            userFields.userFields112 = validateNull(header.userFields112);
            break;
        case 112:
            userFields.userFields113 = validateNull(header.userFields113);
            break;
        case 113:
            userFields.userFields114 = validateNull(header.userFields114);
            break;
        case 114:
            userFields.userFields115 = validateNull(header.userFields115);
            break;
        case 115:
            userFields.userFields116 = validateNull(header.userFields116);
            break;
        case 116:
            userFields.userFields117 = validateNull(header.userFields117);
            break;
        case 117:
            userFields.userFields118 = validateNull(header.userFields118);
            break;
        case 118:
            userFields.userFields119 = validateNull(header.userFields119);
            break;
        case 119:
            userFields.userFields120 = validateNull(header.userFields120);
            break;
        case 120:
            userFields.userFields121 = validateNull(header.userFields121);
            break;
        case 121:
            userFields.userFields122 = validateNull(header.userFields122);
            break;
        case 122:
            userFields.userFields123 = validateNull(header.userFields123);
            break;
        case 123:
            userFields.userFields124 = validateNull(header.userFields124);
            break;
        case 124:
            userFields.userFields125 = validateNull(header.userFields125);
            break;
        case 125:
            userFields.userFields126 = validateNull(header.userFields126);
            break;
        case 126:
            userFields.userFields127 = validateNull(header.userFields127);
            break;
        case 127:
            userFields.userFields128 = validateNull(header.userFields128);
            break;
        case 128:
            userFields.userFields129 = validateNull(header.userFields129);
            break;
        case 129:
            userFields.userFields130 = validateNull(header.userFields130);
            break;
        case 130:
            userFields.userFields131 = validateNull(header.userFields131);
            break;

        default:
            break;

    }

    return userFields;
};

export function validateNull(value) {
    if (value === 0) {
        return value;
    }
    if (!value) {
        return "";
    }

    return (value || '').toString().trim();
};

export function getNCStatus(document) {
    if (document.CANCELED === 'Y') {
        document.status = 'Cancelado';
    } else if (document.U_UDF_UUID) {
        document.status = 'Timbrado';
    } else if (document.DocStatus === 'C' && document.InvntSttus === 'O' && document.DocTotal === document.PaidToDate) {
        document.status = "Pagado";
    } else if (document.DocStatus === 'C') {
        document.status = 'Cerrado';
    } else if (document.DocStatus === 'O') {
        document.status = 'Abierto';
    }
    return document.status
}
export function validateCascoG(propsG) {
    const { props, index, e, item, refreshModel, openItems, refreshTotal } = propsG
    const { showAlert, newOrderModel, enableSpinner, view } = props;
    const newValue = e.target.value;
    const auxModel = { ...newOrderModel }
    const auxItems = auxModel.Items.slice()
    auxItems[index].Casco = newValue;

    if (parseFloat(newValue) === 0) {//ADD CASCO
        newOrderModel.searchItem = 'CASCOSEARCH'
        newOrderModel.indexSearch = index
        auxModel.searchItem = 'CASCOSEARCH'
        auxModel.indexSearch = index
        auxModel.Items = auxItems
        refreshModel(auxModel)
        openItems(item.ItemCode)
    } else {//DELETE CASCO
        const filteredItems = auxItems.filter(
            itm => !(itm.U_FMB_CILINDRO === item.ItemCode && itm.U_FMB_IS_CILINDRO === '1' && itm.WhsCode === item.WhsCode && itm.Quantity === item.Quantity)
        );
        auxModel.Items = filteredItems
        refreshModel(auxModel)
        refreshTotal(auxModel)
    }
}

export function setCascosOrder(props) {
    const { newOrderModel } = props
    let orderedItems = []
    let processedItemCodes = new Set();
    for (let index = 0; index < newOrderModel.Items.length; index++) {
        const item = newOrderModel.Items[index];
        if (item.U_FMB_IS_CILINDRO !== '1' && item.Casco == 0) {
            const keyItem = `${item.ItemCode}${item.WhsCode}${item.Quantity}${index}`
            orderedItems.push(item);
            processedItemCodes.add(keyItem)

            const filteredItems = newOrderModel.Items.filter(
                itm => (itm.U_FMB_CILINDRO === item.ItemCode && itm.U_FMB_IS_CILINDRO === '1' && itm.WhsCode === item.WhsCode && itm.Quantity === item.Quantity)
            );
            for (let idxCilindros = 0; idxCilindros < filteredItems.length; idxCilindros++) {
                const cilindro = filteredItems[idxCilindros];
                const keyItem = `${cilindro.ItemCode}${cilindro.WhsCode}${cilindro.Quantity}${idxCilindros}`
                orderedItems.push(cilindro);
                processedItemCodes.add(keyItem)
            }
        }
    }
    for (let index = 0; index < newOrderModel.Items.length; index++) {
        const item = newOrderModel.Items[index];
        const keyItem = `${item.ItemCode}${item.WhsCode}${item.Quantity}${index}`
        if (!processedItemCodes.has(keyItem) && item.U_FMB_IS_CILINDRO !== '1') {
            orderedItems.push(item);
        }

    }

    newOrderModel.Items = orderedItems;
}

export function getClientCodeText(props) {
    const { newOrderModel } = props
    let clientCardCode = 'Cliente';
    switch (newOrderModel.ObjType) {
        case "540000006":
            clientCardCode = 'Proveedor'
            break;

        default:
            break;
    }
    return clientCardCode

}

export function isMarketingDocument(view) {
    return (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'billing' || view === 'invoiceAdvance' || view === 'invoiceReserve' || view === 'return' || view === 'creditNote' || view === 'pendingTimbraDocs')
}
export const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol, decimals = 2) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(decimals));
    },
};
export function disableDocDueDate(view) {

    return false
}
export function getDueDateFieldName(view) {
    let fieldName = 'Vencimiento'
    return fieldName
}

export async function setDueDateFromPaymentConds(props) {
    const { GroupNum, view, model, showAlert, enableSpinner } = props
    const apiClient = ApiClient.getInstance();

    const search = {
        GroupNum
    }

    enableSpinner(true)
    let paymentCondition = await apiClient.paymentConds(search);
    enableSpinner(false)

    if (paymentCondition.status === SERVICE_RESPONSE.SUCCESS) {
        const payCondition = paymentCondition?.data?.[0] || {}

        let fecha = new Date();
        const año = fecha.getFullYear();
        const mes = fecha.getMonth();

        switch (payCondition.PayDuMonth) {
            case 'E': // E=Month End
                fecha = new Date(año, mes + 1, 0);
                break;
            case 'H': //H=Half Month
                fecha = new Date(año, mes, 15);
                break;
            case 'Y': //Y=Month Start
                fecha = new Date(año, mes + 1, 1);
                break;
            case 'N': // Current Date
                fecha = new Date();
                break;
            default:
                break;

        }
        if (payCondition.PayDuMonth === 'E') {
            fecha = new Date(fecha.getFullYear(), fecha.getMonth() + (payCondition?.ExtraMonth || 0) + 1, 0);
        } else {
            fecha.setMonth(fecha.getMonth() + (payCondition?.ExtraMonth || 0));
        }
        fecha.setDate(fecha.getDate() + (payCondition?.ExtraDays || 0));
        fecha.setDate(fecha.getDate() - (payCondition?.TolDays || 0));

        model.DocDueDate = moment(fecha).format('YYYY-MM-DD');
    } else {
        showAlert({ type: 'error', message: `No se pudo establecer la fecha de ${getDueDateFieldName(view)}` })
    }
}

export function isMarketingDocumentSAP(view) {
    let isMarketingDocSAP = false
    switch (view) {
        case 'quotations':
        case 'orderSales':
        case 'deliveries':
        case 'invoice':
        case 'PurchaseRequest':
            isMarketingDocSAP = true
            break;

        default:
            break;
    }
    return isMarketingDocSAP
}

export async function changeCurrency(amount, currency) {
    if (!amount) { return amount }
    if (!amount || !currency || currency === 'SOL') {
        return { amount: amount || 0 }
    } else {
        const apiClient = ApiClient.getInstance();
        const search = {
            amount, currency
        }
        const apiResponse = await apiClient.convertAmount(search);
        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            return apiResponse.data
        } else {
            return { amount: 0 }
        }
    }
}

export function calcultateOperation(Item, newOrderModel) {//CALCULO DEL TOTAL DE LA LINEA 
    /**
     * ESTA FUNCION CALCULA EL TOTAL DEL ARTICULO 
     * EN CADA MONEDA
     * MONEDA LOCAL
     * MONEDA ACTUAL DEL ITEM
     * MONEDA DE LA CABECERA SELECCIONADA
     * 
     * SIEMPRE SE DEBE MOSTRAR totalHeader QUE ES EL TOTAL
     */
    let totalLocal = 0//CALCULO EN MONEDA LOCAL = CURRENCY
    let totalLineCurrency = 0//CALCULO DE LA MONEDA ACTUAL DEL ITEM
    let totalHeader = 0;//CALCULO EN BASE A LA MONEDA SELECCIONADA EN CABECERA
    const price = Item.Price
    const qty = Item.Quantity
    const discountiTEM = Item.Discount
    const headerCurrency = newOrderModel.DocCur ?? CURRENCY;
    const changeRate = Item.ChangeRateCurrency || 1 //TIPO DE CAMBIO
    if ((Item?.Currency ?? CURRENCY) === CURRENCY) {//PRECIO EN MONEDA LOCAL
        totalLocal = (price * qty) - discountiTEM;
    } else {//CONVERTIR A MONEDA LOCAL
        totalLocal = ((price * changeRate) * qty) - (discountiTEM * changeRate);
    }

    if ((Item?.Currency ?? CURRENCY) === CURRENCY) {//PRECIO EN MONEDA ACTUAL DE LA LINEA
        totalLineCurrency = totalLocal
    } else {
        totalLineCurrency = totalLocal / changeRate
    }
    if (headerCurrency === CURRENCY) {//PRECIO EN BASE A CABECERA
        totalHeader = totalLocal
    } else {
        totalHeader = totalLocal / newOrderModel.ChangeRate || 1
    }
    //totalHeader ES EL QUE SE DEBERIA MOSTRAR SIEMPRE 
    return { totalLocal, totalLineCurrency, totalHeader }
}

export function calcultateOperationHeader(newOrderModel = {}, isPayment = false) { // CALCULO DEL TOTAL DEL DOCUMENTO EN MONEDA LOCAL
    const { Total = 0, DocCur = '', totalPago = 0 } = newOrderModel ?? {};
    let totalLocal = 0;

    const headerCurrency = DocCur ?? CURRENCY;
    if (headerCurrency === CURRENCY) { // Moneda local
        totalLocal = !isPayment ? Number(Total || 0) : Number(totalPago || 0);
    } else { // Convertir total del documento de moneda diferente a la local a moneda local
        totalLocal = (!isPayment ? Number(Total || 0) : Number(totalPago || 0)) * (Number(newOrderModel.ChangeRate || 1));
        totalLocal = Number((totalLocal || 0)?.toFixed(2));
    }

    return { totalLocal }
}

export function changeTipoFigura(value) {
    let newValue = '';
    if (value === '01')
        newValue = 'Llamagas'
    else if (value === '02')
        newValue = 'Propietario'
    else if (value === '03')
        newValue = 'Arrendador'
    else if (value === '04')
        newValue = 'Notificado'
    else if (value === '05')
        newValue = 'Externo'
    return newValue;
};
export function columnOrderByView(view) {
    const defaultOrder = { column: 0, order: 'asc' }
    let finalOrder = defaultOrder
    switch (view) {
        default:
            break;
    }
    return finalOrder
}

export function isMarketingDoc(ObjType) { // Usado para cálculo de multimonedas del documento
    const MARKETING_DOCS = [
        // Ventas
        23,         // Oferta de venta
        17,         // Pedido de venta
        15,         // Entrega
        16,         // Devolución de cliente
        13,         // Factura de venta
        14,         // Nota de crédito de cliente
        203,        // Factura de anticipo

        // Compras
        1470000113, // Solicitud de compra
        540000006,  // Oferta de compra
        22,         // Pedido de compra
        20,         // Entrada de mercancía
        21,         // Devolución de proveedor
        18,         // Factura de compra
        19,         // Nota de crédito de proveedor
        204,        // Factura de anticipo proveedores
    ];

    return MARKETING_DOCS.includes(Number(ObjType));
}

export const roundToDecimals = (num = 0, decimals = 2) => {
    const factor = 10 ** decimals;
    const n = Number(num) || 0;

    const m = Number((Math.abs(n) * factor).toPrecision(15));
    return (Math.round(m) / factor) * Math.sign(n);
};

export const isAnticipo = (itemCode)=>{
    return Anticipo?.includes(itemCode)
}

export const isSalesDocument = (view, ObjType = 0) => {
    const salesDocument = ['quotations', 'orderSales', 'deliveries', 'invoice', 'invoiceAdvance', 'return', 'creditNote', 'debitNote'];
    let isSales = salesDocument?.includes(view);
    const salesObjTypes = [
        23,  // Sales Quotation (OQUT) 
        17,  // Sales Order (ORDR) 
        15,  // Delivery (ODLN) 
        13,  // A/R Invoice (OINV) 
        203, // A/R Down Payment Invoice (ODPI) 
        16,  // Sales Return (ORDN) 
        14,  // A/R Credit Memo (ORIN)
    ];
    if (!isSales) {
        isSales = salesObjTypes?.includes(Number(ObjType));
    }
    return isSales;
};

export const isPurchaseDocument = (view, ObjType = 0) => {
    const purchaseDocument = ['PurchaseRequest', 'PurchaseQuotation', 'PurchaseQuotationDraft', 'PurchaseOrder', 'GoodsReceipt',
        'purchaseReturn', 'purchaseInvoice', 'purchaseCreditNotes', 'purchaseDownPayments']
    let isPurchase = purchaseDocument?.includes(view);
    const purchaseObjTypes = [
        1470000113, // Purchase Request (OPRQ)
        540000006,  // Purchase Quotation (OPQT)
        22,         // Purchase Order (OPOR)
        20,         // Goods Receipt PO (OPDN)
        21,         // Purchase Return (ORPD)
        18,         // A/P Invoice (OPCH)
        19,         // A/P Credit Memo (ORPC)
        204         // A/P Down Payment Invoice (ODPO)
    ];
    if (!isPurchase) {
        isPurchase = purchaseObjTypes?.includes(Number(ObjType));
    }
    return isPurchase;
}